"use Journey";

import { useState } from "react";
import { useToast } from "../components/context/ToastContext";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { IJourney } from "../interfaces/journey";
import {
  fetchJourney,
  saveJourney,
  deleteJourney,
  checkJourneyExists,
} from "../services/journeyService";

export function useJourney(initialPage: number = 1) {
  const showToast = useToast();
  const queryJourney = useQueryClient();

  const [search, setSearch] = useState("");
  const [pageNumber, setPageNumber] = useState(initialPage);
  const [isChecking, setIsChecking] = useState(false);

  const JourneyQuery = useQuery<
    { items: IJourney[]; totalCount: number },
    Error,
    { Journey: IJourney[]; totalPages: number }
  >({
    queryKey: ["Journey", pageNumber, search] as const,
    queryFn: () => fetchJourney(pageNumber, search),
    select: (apiResponse: any) => {
      console.log("apiResponse", apiResponse);
      const items = apiResponse.data.data || [];
      const totalPages = apiResponse.data.totalPages || 1;
      return { Journey: items, totalPages };
    },
    //@ts-ignore
    onError: () => {
      showToast("error", "Erro ao buscar Jornadas.");
    },
  });

  const saveMutation = useMutation({
    mutationFn: (vars: {
      data: IJourney;
      editando: boolean;
      userId?: number;
    }) => saveJourney(vars.data, vars.editando, vars.userId),
    onSuccess: () => {
      queryJourney.invalidateQueries({ queryKey: ["Journey"] });
      showToast("success", "Jornada salva com sucesso.");
    },
    onError: () => {
      showToast("error", "Erro ao salvar Jornada.");
    },
  });

  const deleteMutation = useMutation({
    mutationFn: (id: number) => deleteJourney(id),
    onSuccess: () => {
      queryJourney.invalidateQueries({ queryKey: ["Journey"] });
      showToast("success", "Jornada excluída com sucesso.");
    },
    onError: () => {
      showToast("error", "Erro ao excluir Jornada.");
    },
  });

  function handleSave(data: IJourney, editando: boolean, userId?: number) {
    saveMutation.mutate({ data, editando, userId });
  }

  function handleDelete(id: number) {
    return deleteMutation.mutateAsync(id);
  }

  async function checkIfExists(clientId: number, productId?: number) {
    try {
      setIsChecking(true);
      return await checkJourneyExists(clientId, productId);
    } catch {
      showToast("error", "Erro ao validar existência da Jornada.");
      return false;
    } finally {
      setIsChecking(false);
    }
  }

  const isSaving = saveMutation.status === "pending" || isChecking;

  return {
    Journey: JourneyQuery.data?.Journey || [],
    totalPages: JourneyQuery.data?.totalPages || 1,
    isLoading: JourneyQuery.isLoading,
    isDeleting: deleteMutation.status === "pending",

    // estado de salvamento (mutation)
    isSaving,

    search,
    setSearch,
    pageNumber,
    setPageNumber,

    handleSave,
    handleDelete,

    checkIfExists,
    // refetchJourney: JourneyQuery.refetch,
  };
}
